import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import classNames from 'classnames/bind';
import Box from 'shared_DEPRECATED/components/Box';
import Button from 'shared_DEPRECATED/components/Button';
import { VARIANTS } from 'shared_DEPRECATED/components/Button/config';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import {
  CUSTOM_INPUT,
  SIZES,
} from 'shared_DEPRECATED/components/Form/DatePicker/config';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer, { Spacers } from 'shared_DEPRECATED/components/Spacer';

import { Typography } from 'shared/components/Typography';

import styles from '../../../Button/Button.module.css';

const DatePickerAnchorPropTypes = {
  icon: PropTypes.oneOf(Object.values(iconNames)),
  value: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf([VARIANTS.TERTIARY, VARIANTS.SECONDARY]),
  placeholder: PropTypes.string,
  size: PropTypes.oneOf([SIZES.SM, SIZES.LG]),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

const cx = classNames.bind(styles);

export const DatePickerAnchor = forwardRef(
  (
    {
      disabled = false,
      value,
      icon,
      onClick,
      dataTestId,
      variant,
      placeholder,
      size = SIZES.LG,
      error,
    },
    ref
  ) => (
    <Box ref={ref}>
      <Button
        disabled={disabled}
        onClick={onClick}
        variant={variant}
        className={cx({
          'btn--error': error,
        })}
        dataTestid={dataTestId}
      >
        <Spacers sizes={CUSTOM_INPUT[size].spacers}>
          <Flex alignItems="center" width="100%">
            {icon && (
              <>
                <Icon
                  name={icon}
                  width={CUSTOM_INPUT[size].icon.width}
                  height={CUSTOM_INPUT[size].icon.height}
                />
                <Spacer size="zr md zr zr" />
              </>
            )}
            {value ? (
              <Typography
                as="span"
                type={CUSTOM_INPUT[size].fontSize}
                color="black"
                fontWeight="medium"
              >
                {value}
              </Typography>
            ) : (
              <Typography
                as="span"
                type={CUSTOM_INPUT[size].fontSize}
                color="gray"
              >
                {placeholder}
              </Typography>
            )}
          </Flex>
        </Spacers>
      </Button>
    </Box>
  )
);

DatePickerAnchor.propTypes = DatePickerAnchorPropTypes;
